import { WorkingArea } from '@/constants/user/userWorkingArea'

import { basePath } from '../../next.config'

export const handleLogin = async (
	email: string,
	callbacks: {
		setLoadingUserId: (id: string | null) => void
		setError: (error: string | null) => void
	}
): Promise<void> => {
	const { setLoadingUserId, setError } = callbacks
	setLoadingUserId(email)
	setError(null)

	try {
		const response = await fetch(`${basePath}/api/musicapp/login`, {
			body: JSON.stringify({ email }),
			method: 'POST',
		})

		if (response.ok) {
			setLoadingUserId(null)
			window.location.reload()
		} else {
			setError(`${response.status}: ${response.statusText} 👎`)
			setLoadingUserId(null)
		}
	} catch (err) {
		setError(`Login failed: ${err.message}`)
		setLoadingUserId(null)
	}
}

export const handleLogout = (
	setLoggedInUser: (user: string | null) => void
): void => {
	document.cookie = '.auth=;expires=' + new Date(0).toUTCString() + ';path=/'
	setLoggedInUser(null)
	window.location.reload()
}

export const handleCreateUser = async (
	setLoadingUserId: (id: string | null) => void,
	setError: (error: string | null) => void,
	workingArea?: WorkingArea
): Promise<void> => {
	const email = `test-trial-user${crypto
		.randomUUID()
		.slice(0, 8)}@guerrillamail.com`
	setLoadingUserId(email)
	setError(null)

	try {
		const response = await fetch(`${basePath}/api/musicapp/registration`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				email: email,
				workingArea: workingArea || WorkingArea['TV & Film'],
			}),
		})

		if (response.ok) {
			await handleLogin(email, { setLoadingUserId, setError })
		} else {
			setError(
				`Registration failed: ${response.status}: ${response.statusText} 👎`
			)
			setLoadingUserId(null)
		}
	} catch (err) {
		setError(`Registration failed: ${err.message}`)
		setLoadingUserId(null)
	}
}

export const handleCreateCart = async (): Promise<void> => {
	const cartToken = 'ecb09844-cf00-4325-bf95-e11cc9201126'
	document.cookie = `CartToken=${cartToken};path=/`
	window.location.reload()
}
